import GameObject from '../../GameObject/GameObject';
import ParticlesComponent from '../../Component/Particles';
import TransformComponent from '../../Component/Transform';
import Renderable from '../../Component/Renderable';
import RelativePositionComponent from '../../Component/Render/RelativePosition';
import DateHelper from '../../Utility/DateHelper';
import Game from '../../Game';
import { TickerEvent } from '../../Utility/Ticker';

export default class ParticleEmitter extends GameObject {
    public onCreate(params: any): void {
        this.addComponent<TransformComponent>(TransformComponent, params);
        this.addComponent<Renderable>(Renderable, params);

        if (params.relativePosition) {
            this.addComponent<RelativePositionComponent>(
                RelativePositionComponent,
                params
            );
        }

        this.addComponent(ParticlesComponent, {
            elapsedTime: DateHelper.now,
            ...params,
        });
    }

    public readonly start = (): void => {
        const particleComponent: ParticlesComponent = this.getComponent(
            ParticlesComponent
        );

        if (!particleComponent) return;

        particleComponent.emitter.emit = true;

        this.update();
        Game.ticker.on(TickerEvent.TICK, this.update);
    }

    public stop(): void {
        const particleComponent: ParticlesComponent = this.getComponent(
            ParticlesComponent
        );

        particleComponent.emitter.emit = false;

        Game.ticker.off(TickerEvent.TICK, this.update);
        this.update();
    }

    private readonly update = () => {
        if (this.destroyed) {
            Game.ticker.off(TickerEvent.TICK, this.update);
            return;
        }

        const particleComponent: ParticlesComponent = this.getComponent(
            ParticlesComponent
        );

        const now = Game.ticker.getNow();
        particleComponent.emitter.update(
            (now - particleComponent.elapsedTime) * 0.001
        );
        particleComponent.elapsedTime = now;
    };
    public destroy() {
        const particleComponent: ParticlesComponent = this.getComponent(
            ParticlesComponent
        );

        particleComponent.emitter.destroy();

        Game.ticker.off(TickerEvent.TICK, this.update);

        super.destroy();
    }
}
